var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCandidateSignUpBenefits2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 43.742,
    height: 44.499,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_4715",
    x: 0,
    y: 0,
    width: 43.742,
    height: 44.499,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4711",
    "data-name": "Rectangle 4711",
    width: 18.171,
    height: 18.171,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_24419",
    "data-name": "Group 24419",
    transform: "translate(-73.531 -536)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 73.53, 536)",
    filter: "url(#Rectangle_4715)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4715-2",
    "data-name": "Rectangle 4715",
    width: 25.742,
    height: 26.499,
    rx: 4,
    transform: "translate(9 6)",
    fill: "#040227"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_24406",
    "data-name": "Group 24406",
    transform: "translate(86.317 546.543)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24405",
    "data-name": "Group 24405",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46373",
    "data-name": "Path 46373",
    d: "M343.407,68.264a2.083,2.083,0,1,0,2.083,2.083,2.083,2.083,0,0,0-2.083-2.083m0,3.571a1.488,1.488,0,1,1,1.488-1.488,1.488,1.488,0,0,1-1.488,1.488",
    transform: "translate(-329.419 -65.883)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46374",
    "data-name": "Path 46374",
    d: "M376.944,102.993h-.3v-.3a.3.3,0,0,0-.6,0v.3h-.3a.3.3,0,1,0,0,.6h.3v.3a.3.3,0,1,0,.6,0v-.3h.3a.3.3,0,0,0,0-.6Z",
    transform: "translate(-362.361 -98.827)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46375",
    "data-name": "Path 46375",
    d: "M16.666,1.191h-.893v-.3A.893.893,0,0,0,14.88,0H13.094A.893.893,0,0,0,12.2.894v.3h-.893a1.19,1.19,0,0,0-1.19,1.19V5.2A3.821,3.821,0,0,0,7.49,4.858,6.69,6.69,0,0,0,7.737,3V1.365a.593.593,0,0,0-.568-.6A3.214,3.214,0,0,1,5.142.142a.588.588,0,0,0-.764,0A3.222,3.222,0,0,1,2.355.767a.593.593,0,0,0-.57.6V3c0,2.264.934,3.922,2.629,4.67a.816.816,0,0,0,.163.053,3.82,3.82,0,0,0,.482,2.973,3.022,3.022,0,0,0-1.25-.274h-.59a.893.893,0,0,0-.838-.6H.892A.893.893,0,0,0,0,10.715v6.25a.893.893,0,0,0,.893.893H2.38a.888.888,0,0,0,.661-.3H10.5a2.378,2.378,0,0,0,1.238-.347l5.577-3.4a1.11,1.11,0,0,0,.333-1.59.243.243,0,0,0-.021-.03,1.118,1.118,0,0,0-1.242-.389l-5.511,1.836a.876.876,0,0,1-.282.046h-.241a1.391,1.391,0,0,0-.067-1.216,1.761,1.761,0,0,0-.282-.355,3.85,3.85,0,0,0,2.086-4.381h4.572a1.19,1.19,0,0,0,1.19-1.19V2.382a1.19,1.19,0,0,0-1.19-1.19ZM12.8.894a.3.3,0,0,1,.3-.3H14.88a.3.3,0,0,1,.3.3v.3H12.8v-.3ZM4.655,7.121A4.177,4.177,0,0,1,2.38,3l0-1.634A3.715,3.715,0,0,0,4.754.593a3.809,3.809,0,0,0,2.388.772V3A5.737,5.737,0,0,1,6.78,5.09,3.892,3.892,0,0,0,4.761,7.144.256.256,0,0,1,4.655,7.121ZM2.38,17.263H.892a.3.3,0,0,1-.3-.3v-6.25a.3.3,0,0,1,.3-.3H2.38a.3.3,0,0,1,.3.3v6.25A.3.3,0,0,1,2.38,17.263Zm5.572-3.571a2.983,2.983,0,0,0-1.651.5l-.218.146a.3.3,0,0,0,.332.495l.215-.145a2.387,2.387,0,0,1,1.321-.4H10.6a1.466,1.466,0,0,0,.472-.078l5.507-1.836a.522.522,0,0,1,.565.163l.015.021a.515.515,0,0,1-.146.751l-5.577,3.4a1.783,1.783,0,0,1-.929.26H3.273V11.013h.536a2.426,2.426,0,0,1,1.511.53A3.026,3.026,0,0,0,7.2,12.2H8.758a1.2,1.2,0,0,1,1.021.578.842.842,0,0,1-.095.91Zm1.442-1.964a1.777,1.777,0,0,0-.635-.119H7.2a2.37,2.37,0,0,1-.268-.017,3.274,3.274,0,1,1,2.46.137Zm7.867-5.179a.6.6,0,0,1-.6.6H11.9a3.886,3.886,0,0,0-1.19-1.555V2.382a.6.6,0,0,1,.6-.6h5.357a.6.6,0,0,1,.6.6V6.549Z",
    transform: "translate(0.001 -0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46376",
    "data-name": "Path 46376",
    d: "M96.822,59.789a.3.3,0,0,0-.417.06l-1.58,2.107-.353-.353a.3.3,0,0,0-.421.421l.6.6a.3.3,0,0,0,.21.087h.021a.3.3,0,0,0,.217-.119l1.786-2.381a.3.3,0,0,0-.06-.417",
    transform: "translate(-90.691 -57.646)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46377",
    "data-name": "Path 46377",
    d: "M205.984,180.087a.6.6,0,0,1,.6.6.3.3,0,1,0,.6,0,1.191,1.191,0,0,0-.893-1.148v-.042a.3.3,0,1,0-.6,0v.042a1.188,1.188,0,0,0,.3,2.339.6.6,0,1,1-.6.6.3.3,0,1,0-.6,0,1.19,1.19,0,0,0,.893,1.148v.042a.3.3,0,1,0,.6,0v-.042a1.188,1.188,0,0,0-.3-2.339.6.6,0,1,1,0-1.191Z",
    transform: "translate(-197.651 -172.944)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandidateSignUpBenefits2);
export default __webpack_public_path__ + "static/media/candidate-sign-up-benefits-2.52024afcbe1a4b533c346ff07884ff1a.svg";
export { ForwardRef as ReactComponent };